import { render, staticRenderFns } from "./main-page.vue?vue&type=template&id=4cb3f32d&scoped=true&"
import script from "./main-page.vue?vue&type=script&lang=js&"
export * from "./main-page.vue?vue&type=script&lang=js&"
import style0 from "./main-page.vue?vue&type=style&index=0&id=4cb3f32d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb3f32d",
  null
  
)

export default component.exports